import axios from 'axios';

// Base URLs matching your FastAPI configuration
// const API_BASE_URL = 'http://127.0.0.1:8000/api';
const API_BASE_URL = 'api2.nextorbitals.in/api/tradingAPI/market_breadth.php?';
const WS_BASE_URL = 'ws://localhost:8000/ws/live';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 189999, // Increased timeout because market-breadth calculation might take time
});

/**
 * 1. Save Login Credentials
 * Matches POST /api/login
 */
export const login = async (credentials) => {
  try {
    const response = await api.post('/login/', credentials);
    console.log("Login response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error saving login:", error);
    throw error;
  }
};

/**
 * 2. Fetch distinct index names and symbols
 * Matches GET /api/indices
 */
export const fetchIndicesList = async () => {
  try {
    const response = await api.get('/indices/');
    return response.data;
  } catch (error) {
    console.error("Error fetching indices list:", error);
    throw error;
  }
};

/**
 * 3. Trigger background scraper
 * Matches GET /api/load_indices
 */
export const triggerIndexScraper = async () => {
  try {
    const response = await api.get('/load_indices');
    return response.data;
  } catch (error) {
    console.error("Error triggering scraper:", error);
    throw error;
  }
};

/**
 * 4. Fetch Market Breadth Data (SMA Percentages)
 * Matches POST /api/market-breadth
 */
// export const fetchMarketBreadth = async (payload) => {
//   try {
//     const response = await api.post('/market-breadth', payload);
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching market breadth data:", error);
//     throw error;
//   }
// };

/**
 * 5. Connect to Live WebSocket Feed
 * Matches WS /ws/live
 */
export const connectLiveWebSocket = (onMessageCallback) => {
  const ws = new WebSocket(WS_BASE_URL);
  
  ws.onopen = () => {
    console.log('✅ Connected to live market data websocket');
  };
  
  ws.onmessage = (event) => {
    const data = JSON.parse(event.data);
    onMessageCallback(data);
  };
  
  ws.onerror = (error) => {
    console.error('❌ WebSocket Error:', error);
  };
  
  ws.onclose = () => {
    console.log('🔴 Disconnected from live market data');
  };
  
  return ws; // Return the instance so components can close it on unmount
};

// src/services/api.js

/**
 * 4. Fetch Market Breadth Data (SMA Percentages)
 * Matches GET /api/breadth/<timeframe>/<chart_points>/<target_index>/
 */
export const fetchMarketBreadth = async (timeframe, chartPoints = 100, indexName = 'NIFTY NEXT 50') => {
  const encodedIndex = encodeURIComponent(indexName);
  const url = `https://api2.nextorbitals.in/api/tradingAPI/market_breadth.php?timeframe=${timeframe}&index_name=${encodedIndex}&chart_points=${chartPoints}`;

  const res = await fetch(url);
  const text = await res.text();

  let json;
  try { json = JSON.parse(text); }
  catch { throw new Error(`Non-JSON response (${res.status}): ${text.slice(0, 200)}`); }

  if (!res.ok) throw new Error(json?.error || `HTTP ${res.status}`);

  // adjust these fields to match the REAL API shape you see in `json`
  const ok = json?.status ?? json?.data?.status;
  const payload = json?.data?.data ?? json?.data ?? json;

  if (!ok) throw new Error(json?.error || json?.data?.error || 'API returned status=false');

  return payload;
  
};


/**
 * Add a Custom Trading Session (Django Backend)
 * Matches POST /api/add_session/
 */
export const addCustomSession = async (sessionData) => {
  try {
    const response = await api.post('/add_session/', sessionData);
    return response.data;
  } catch (error) {
    console.error("Error adding custom session:", error);
    throw error;
  }
};

/**
 * Get Custom Trading Sessions for Current Year (Django Backend)
 * Matches GET /api/get_sessions/
 */
export const getCustomSessions = async () => {
  try {
    const response = await api.get('/get_sessions/');
    return response.data;
  } catch (error) {
    console.error("Error fetching custom sessions:", error);
    throw error;
  }
};

/**
 * Delete Custom Trading Sessions by Date (Django Backend)
 * Matches POST /api/delete_session/ (or wherever your URL is mapped)
 */
export const deleteCustomSession = async (dateStr) => {
  try {
    const response = await api.post('/delete_session/', { date: dateStr });
    return response.data;
  } catch (error) {
    console.error(`Error deleting session for ${dateStr}:`, error);
    throw error;
  }
};




